import type { AccountGroupId } from './constants';
import type { AccountRow } from './types';

export type AccountRowOrder = Partial<Record<AccountGroupId, readonly string[]>>;

export function applyRowOrder(rows: readonly AccountRow[], storedIds: readonly string[] | undefined) {
  if (storedIds === undefined || storedIds.length === 0) {
    return rows;
  }
  const known = rows.filter((row) => storedIds.includes(row.id));
  const added = rows.filter((row) => !storedIds.includes(row.id));
  const ordered = [...known].sort((left, right) => storedIds.indexOf(left.id) - storedIds.indexOf(right.id));
  return [...ordered, ...added];
}

export function moveRowTo(rowIds: readonly string[], movedId: string, targetId: string) {
  if (movedId === targetId) {
    return rowIds;
  }
  const from = rowIds.indexOf(movedId);
  const to = rowIds.indexOf(targetId);
  if (from === -1 || to === -1) {
    return rowIds;
  }
  const remaining = rowIds.filter((id) => id !== movedId);
  remaining.splice(to, 0, movedId);
  return remaining;
}

export function moveRowBy(rowIds: readonly string[], movedId: string, offset: number) {
  const from = rowIds.indexOf(movedId);
  const to = from + offset;
  if (from === -1 || to < 0 || to >= rowIds.length) {
    return rowIds;
  }
  const target = rowIds[to];
  return target === undefined ? rowIds : moveRowTo(rowIds, movedId, target);
}

export function orderPosition(rowIds: readonly string[], rowId: string) {
  const index = rowIds.indexOf(rowId);
  return {
    isFirst: index === 0,
    isLast: index === rowIds.length - 1,
  };
}
